export const indexItems = [
  { id: 1, title: '韩漫精选', desc: '高人气韩国漫画持续更新', icon: 'ri-global-line', count: '2,860', tag: '热门', tagColor: 'bg-accent-500', iconBg: 'bg-accent-100', iconColor: 'text-accent-600' },
  { id: 2, title: '日漫经典', desc: '日系漫画殿堂级作品合集', icon: 'ri-earth-line', count: '5,120', tag: '经典', tagColor: 'bg-primary-500', iconBg: 'bg-primary-100', iconColor: 'text-primary-600' },
  { id: 3, title: '国漫崛起', desc: '国产原创漫画强力推荐', icon: 'ri-train-line', count: '3,450', tag: '新番', tagColor: 'bg-secondary-500', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-600' },
  { id: 4, title: '恋爱甜宠', desc: '心动甜蜜恋爱漫画专题', icon: 'ri-heart-line', count: '1,980', tag: '甜', tagColor: 'bg-accent-400', iconBg: 'bg-accent-100', iconColor: 'text-accent-500' },
  { id: 5, title: '热血战斗', desc: '高燃战斗漫画燃爆全场', icon: 'ri-fire-line', count: '2,340', tag: '燃', tagColor: 'bg-primary-400', iconBg: 'bg-primary-100', iconColor: 'text-primary-500' },
  { id: 6, title: '悬疑推理', desc: '烧脑推理漫画等你来破案', icon: 'ri-eye-line', count: '1,560', tag: '烧脑', tagColor: 'bg-secondary-400', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-500' },
  { id: 7, title: '完结神作', desc: '已完结高分漫画一次看够', icon: 'ri-check-double-line', count: '4,200', tag: '完结', tagColor: 'bg-accent-600', iconBg: 'bg-accent-100', iconColor: 'text-accent-700' },
];

export const featureItems = [
  { id: 1, title: '海量漫画库', desc: '收录超过10万部韩漫、日漫、国漫，每日稳定更新50+章节，类型覆盖恋爱、奇幻、热血、悬疑等全品类', icon: 'ri-database-2-line' },
  { id: 2, title: '下拉式流畅阅读', desc: '独家下拉式阅读模式，无需翻页点击，一气呵成沉浸式畅读体验，支持夜间模式与字号调节', icon: 'ri-arrow-down-line' },
  { id: 3, title: '完全免费', desc: '所有漫画全集免费在线观看，无隐藏收费，无需会员注册即可畅享全部内容，真正零门槛', icon: 'ri-vip-crown-line' },
  { id: 4, title: '高清画质', desc: '全站漫画采用高清图源，每一页都经过精心优化，支持视网膜屏幕显示，细节清晰不模糊', icon: 'ri-hd-line' },
  { id: 5, title: '智能推荐', desc: '基于阅读偏好智能推送你可能喜欢的漫画，追更提醒不再错过任何更新，个性化你的漫画之旅', icon: 'ri-magic-line' },
];

export const carouselItems = [
  {
    id: 1,
    title: '《秘密课堂》—— 人气韩漫霸榜之作',
    desc: '校园恋爱与悬疑交织，当学霸的秘密被揭开的瞬间，故事走向令人窒息。全网点阅量突破 3 亿，是今年不可错过的韩漫话题王。',
    tag: '韩漫霸榜',
    views: '3.2亿',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20high%20school%20romance%20with%20suspense%2C%20two%20characters%20in%20school%20uniforms%20standing%20in%20a%20cherry%20blossom%20campus%2C%20warm%20orange%20and%20pink%20lighting%2C%20emotional%20tension%2C%20anime%20art%20style%2C%20clean%20composition%20with%20soft%20background&width=800&height=500&seq=manga-carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《咒术回战》—— 日漫巅峰战力的终极对决',
    desc: '芥见下下原作改编，咒术高专与宿傩的世纪之战白热化。每话更新必上热搜，日漫迷不可不追的年度巨制。',
    tag: '日漫巅峰',
    views: '8.6亿',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Japanese%20manga%20style%20battle%20scene%20with%20supernatural%20energy%20effects%2C%20a%20powerful%20sorcerer%20character%20with%20dynamic%20action%20pose%2C%20dark%20dramatic%20lighting%20with%20orange%20and%20red%20energy%20waves%2C%20anime%20art%20style%2C%20intense%20composition&width=800&height=500&seq=manga-carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《一人之下》—— 国漫之光再掀异能风暴',
    desc: '米二笔下的异人世界持续扩展，张楚岚与冯宝宝的冒险进入全新篇章。精美国风画面配合道家文化底蕴，国漫标杆。',
    tag: '国漫之光',
    views: '5.8亿',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20martial%20arts%20scene%20with%20taoist%20elements%2C%20a%20young%20warrior%20with%20flowing%20traditional%20clothing%2C%20mystical%20energy%20surrounding%20them%2C%20ancient%20Chinese%20architecture%20in%20background%2C%20warm%20golden%20and%20red%20tones%2C%20dramatic%20composition&width=800&height=500&seq=manga-carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《我独自升级》—— 全球现象级漫画改编动画',
    desc: '从E级猎人到世界最强，成振宇的逆袭之路震撼全球。动画化后热度再创新高，漫画原作更是值得反复品读。',
    tag: '全球现象',
    views: '12.5亿',
    image: 'https://readdy.ai/api/search-image?query=Solo%20leveling%20style%20Korean%20manhwa%20illustration%2C%20a%20dark%20powerful%20hunter%20with%20glowing%20purple%20eyes%20and%20black%20armor%2C%20shadow%20army%20behind%20him%2C%20epic%20scale%2C%20dramatic%20lighting%20with%20dark%20and%20neon%20contrast%2C%20intense%20action%20vibe&width=800&height=500&seq=manga-carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《间谍过家家》—— 温馨搞笑间谍家庭喜剧',
    desc: '远藤达哉创作的现象级作品，间谍父亲、杀手母亲与读心术女儿的奇妙家庭日常，温暖又爆笑的全年龄向神作。',
    tag: '全龄神作',
    views: '6.9亿',
    image: 'https://readdy.ai/api/search-image?query=Spy%20family%20style%20Japanese%20manga%20illustration%2C%20a%20happy%20family%20of%20three%20in%20elegant%20clothing%2C%20warm%20cozy%20living%20room%20setting%2C%20soft%20golden%20hour%20lighting%2C%20playful%20and%20heartwarming%20atmosphere%2C%20anime%20art%20style%2C%20clean%20composition&width=800&height=500&seq=manga-carousel-05&orientation=landscape',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '《剑尊归来》',
    desc: '死后百年重生归来的剑道至尊，在现代都市重建宗门，热血与搞笑并存的韩漫佳作',
    tag: '重生',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20swordmaster%20in%20modern%20city%2C%20wearing%20traditional%20martial%20arts%20robe%20with%20a%20sword%2C%20urban%20background%20with%20neon%20lights%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20dark%20tones%2C%20anime%20style&width=600&height=400&seq=manga-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《电锯人》第二部',
    desc: '藤本树最新连载，淀治的校园生活与新恶魔的登场，荒诞又深刻的叙事风格持续炸裂',
    tag: '连载中',
    image: 'https://readdy.ai/api/search-image?query=Chainsaw%20man%20style%20Japanese%20manga%20illustration%2C%20a%20teenage%20character%20with%20chainsaw%20arms%20in%20urban%20setting%2C%20chaotic%20action%20scene%2C%20red%20and%20orange%20color%20palette%2C%20punk%20aesthetic%2C%20anime%20art%20style&width=600&height=400&seq=manga-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《全职高手》番外',
    desc: '叶修重返荣耀之巅后全新故事线，蝴蝶蓝监修，国漫顶流IP的又一次精彩延展',
    tag: '国漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20esports%20battle%20scene%2C%20a%20skilled%20gamer%20character%20with%20headset%2C%20digital%20battlefield%20background%2C%20dynamic%20action%20with%20glowing%20effects%2C%20warm%20golden%20and%20red%20tones&width=600&height=400&seq=manga-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《葬送的芙莉莲》',
    desc: '勇者死后精灵魔法使的旅程，跨越时间的深情叙事，日漫年度口碑最佳之作',
    tag: '治愈',
    image: 'https://readdy.ai/api/search-image?query=Frieren%20style%20Japanese%20manga%20illustration%2C%20an%20elf%20mage%20walking%20through%20a%20beautiful%20meadow%20at%20sunset%2C%20nostalgic%20and%20melancholic%20atmosphere%2C%20warm%20golden%20and%20soft%20green%20colors%2C%20peaceful%20composition&width=600&height=400&seq=manga-card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《反派初始化》',
    desc: '穿越成为游戏反派角色，用现代思维改写剧情走向，国漫反套路搞笑佳作',
    tag: '搞笑',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20fantasy%20illustration%2C%20a%20character%20in%20ancient%20Chinese%20cultivation%20robe%20with%20modern%20expression%2C%20palace%20background%2C%20humorous%20and%20light%20atmosphere%2C%20warm%20and%20vibrant%20colors&width=600&height=400&seq=manga-card-05&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '妖精漫画网上的漫画真的完全免费吗？',
    answer: '是的，妖精漫画网所有漫画全集均免费在线观看，无需任何付费。我们通过广告合作维持运营，确保读者可以零门槛畅享海量韩漫、日漫、国漫内容。',
  },
  {
    id: 2,
    question: '网站上的漫画更新频率是怎样的？',
    answer: '我们每日稳定更新50+章节，热门连载漫画与官方同步更新。韩漫通常每周更新2-3话，日漫和国漫根据连载节奏同步跟进，确保读者第一时间看到最新章节。',
  },
  {
    id: 3,
    question: '支持在手机上阅读漫画吗？',
    answer: '完全支持。妖精漫画网采用响应式设计，在手机、平板和电脑上均可获得流畅的阅读体验。我们还特别优化了下拉式阅读模式，手机端阅读更加舒适自然。推荐使用Chrome或Safari浏览器获得最佳体验。',
  },
  {
    id: 4,
    question: '如何找到我想看的漫画类型？',
    answer: '您可以通过首页顶部的分类导航、专题索引区域快速找到感兴趣的漫画类型。我们还提供智能推荐功能，根据您的阅读偏好推送相似作品，帮助您发现更多好看的漫画。',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '漫画迷小K',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20girl%20avatar%20portrait%2C%20simple%20warm%20background%2C%20soft%20lighting%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2026-07-27',
    rating: 5,
    content: '用了妖精漫画半年了，真的是我见过最好用的漫画站！下拉阅读模式太爽了，一滑到底不用点翻页。更新速度也很快，追的几部韩漫基本和韩国同步。',
    comic: '《秘密课堂》',
  },
  {
    id: 2,
    name: '二次元宅男',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20boy%20avatar%20portrait%2C%20simple%20warm%20background%2C%20casual%20expression%2C%20soft%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2026-07-26',
    rating: 5,
    content: '日漫库真的很全，很多冷门老番都能找到，画质也高清。最重要的是免费！以前在别的平台花钱看，现在全转到这里了。推荐给了好多朋友。',
    comic: '《咒术回战》',
  },
  {
    id: 3,
    name: '国漫铁粉',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20portrait%20with%20glasses%2C%20warm%20background%2C%20gentle%20smile%2C%20soft%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2026-07-25',
    rating: 4,
    content: '国漫区越来越精彩了！《一人之下》《全职高手》更新都很及时。希望以后能增加更多国产原创漫画的推荐和专题，支持国漫发展！',
    comic: '《一人之下》',
  },
];

export const topicItems = [
  { id: 1, name: '韩漫推荐', heat: '12.8万', color: 'bg-accent-100 text-accent-800' },
  { id: 2, name: '日漫新番', heat: '9.6万', color: 'bg-primary-100 text-primary-800' },
  { id: 3, name: '国漫崛起', heat: '8.3万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 4, name: '恋爱漫画', heat: '7.5万', color: 'bg-accent-100/80 text-accent-700' },
  { id: 5, name: '热血战斗', heat: '6.9万', color: 'bg-primary-100/80 text-primary-700' },
  { id: 6, name: '悬疑推理', heat: '5.4万', color: 'bg-secondary-100/80 text-secondary-700' },
  { id: 7, name: '穿越重生', heat: '10.2万', color: 'bg-accent-100 text-accent-800' },
  { id: 8, name: '搞笑日常', heat: '5.8万', color: 'bg-primary-100 text-primary-800' },
  { id: 9, name: '奇幻冒险', heat: '4.7万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 10, name: '完结神作', heat: '11.3万', color: 'bg-accent-100/80 text-accent-700' },
];

export const mediaItems = [
  {
    id: 1,
    title: '《剑尊归来》漫评：「重生+搞笑=年度最佳韩漫」',
    author: '漫画解说君',
    views: '56.8万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20review%20thumbnail%20style%2C%20swordmaster%20character%20in%20modern%20setting%20with%20dramatic%20lighting%2C%20text%20overlay%20space%2C%20warm%20orange%20and%20dark%20contrast%2C%20YouTube%20style%20composition&width=640&height=360&seq=manga-media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '一口气看完《我独自升级》全剧情：从弱鸡到最强猎人',
    author: '速读漫画',
    views: '128.3万',
    image: 'https://readdy.ai/api/search-image?query=Solo%20leveling%20story%20recap%20thumbnail%20style%2C%20dark%20hunter%20with%20glowing%20effects%20and%20shadow%20army%2C%20epic%20scale%2C%20dramatic%20red%20and%20black%20contrast%2C%20video%20thumbnail%20composition&width=640&height=360&seq=manga-media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《电锯人》第二部深度分析：藤本树到底想表达什么',
    author: '深度漫画',
    views: '39.2万',
    image: 'https://readdy.ai/api/search-image?query=Chainsaw%20man%20analysis%20thumbnail%20style%2C%20character%20closeup%20with%20chainsaw%20arms%20in%20chaotic%20scene%2C%20dark%20and%20red%20color%20palette%2C%20punk%20aesthetic%2C%20dramatic%20video%20thumbnail&width=640&height=360&seq=manga-media-03&orientation=landscape',
  },
];

export const updateItems = [
  { id: 1, date: '2026-07-28', tag: '更新', tagColor: 'bg-primary-500', title: '《秘密课堂》第128话已更新 —— 真相揭晓的瞬间，她做出了选择', time: '2小时前' },
  { id: 2, date: '2026-07-28', tag: '新作', tagColor: 'bg-accent-500', title: '新连载《魔道祖师》漫画版正式上线 —— 墨香铜臭经典改编', time: '5小时前' },
  { id: 3, date: '2026-07-27', tag: '更新', tagColor: 'bg-primary-500', title: '《咒术回战》第261话 —— 宿傩VS五条悟最终决战开始', time: '1天前' },
  { id: 4, date: '2026-07-27', tag: '专题', tagColor: 'bg-secondary-500', title: '「2026夏日漫画节」专题上线 —— 百部热门漫画限时推荐', time: '1天前' },
  { id: 5, date: '2026-07-26', tag: '更新', tagColor: 'bg-primary-500', title: '《一人之下》第612话 —— 异人世界的规则被重新书写', time: '2天前' },
  { id: 6, date: '2026-07-26', tag: '公告', tagColor: 'bg-accent-600', title: '全站阅读器升级完成 —— 支持更多字体选择和阅读模式切换', time: '2天前' },
  { id: 7, date: '2026-07-25', tag: '更新', tagColor: 'bg-primary-500', title: '《剑尊归来》第95话 —— 宗门重建计划启动', time: '3天前' },
  { id: 8, date: '2026-07-25', tag: '新作', tagColor: 'bg-accent-500', title: '《反派初始化》第二季正式开更 —— 全新剧情线精彩加倍', time: '3天前' },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '我独自升级', type: '韩漫', heat: '🔥 12.5亿', trend: 'up' },
  { id: 2, rank: 2, title: '咒术回战', type: '日漫', heat: '🔥 8.6亿', trend: 'up' },
  { id: 3, rank: 3, title: '秘密课堂', type: '韩漫', heat: '🔥 3.2亿', trend: 'up' },
  { id: 4, rank: 4, title: '一人之下', type: '国漫', heat: '5.8亿', trend: 'stable' },
  { id: 5, rank: 5, title: '剑尊归来', type: '韩漫', heat: '4.1亿', trend: 'up' },
];